export default {
  // Navigation
  nav: {
    home: 'Home',
    about: 'About',
    contact: 'Contact',
    admin: 'Admin',
    backToHome: '← Back to home'
  },

  // Home page (Upload)
  home: {
    title: 'ProTransfert',
    subtitle: 'Share your files securely',
    aboutLink: 'About ProTransfert',
    contactLink: 'Contact us',
    uploadTitle: 'Drag and drop your file',
    uploadSubtitle: 'or click to select a file',
    clickToUpload: 'Click to upload',
    dragAndDrop: 'or drag and drop',
    maxSize: 'Maximum size',
    removeFile: 'Remove and choose another file',
    recipientEmail: 'Recipient email',
    recipientEmailPlaceholder: 'recipient@example.com',
    message: 'Message (optional)',
    messagePlaceholder: 'Add a message for the recipient...',
    uploadButton: 'Send file',
    uploading: 'Uploading...',
    uploadSuccess: 'File sent successfully!',
    uploadError: 'Error sending file'
  },

  // About page
  about: {
    title: 'About ProTransfert',
    subtitle: 'The French secure file transfer solution, designed for businesses and demanding professionals.',
    madeInFrance: 'Made in France',
    madeInFranceSubtitle: 'Developed and hosted in France',
    features: {
      security: {
        title: 'Maximum security',
        description: 'End-to-end encryption, secure authentication and protection against unauthorized access.'
      },
      speed: {
        title: 'Ultra-fast transfer',
        description: 'Optimized for large file transfers with maximum speed.'
      },
      interface: {
        title: 'Intuitive interface',
        description: 'Modern and responsive interface, accessible from all devices.'
      },
      rgpd: {
        title: 'GDPR compliant',
        description: 'Full compliance with the European General Data Protection Regulation.'
      },
      management: {
        title: 'Advanced management',
        description: 'Download tracking, email notifications and access control.'
      },
      support: {
        title: 'French support',
        description: 'Technical support in French, available to assist you.'
      }
    },
    rgpd: {
      title: 'GDPR Compliance',
      subtitle: 'ProTransfert strictly respects the General Data Protection Regulation',
      yourRights: 'Your rights',
      ourCommitments: 'Our commitments',
      rights: {
        access: 'Right of access to your data',
        rectification: 'Right of rectification',
        erasure: 'Right to erasure',
        portability: 'Right to data portability'
      },
      commitments: {
        encryption: 'Data encryption',
        hosting: 'Hosting in France',
        deletion: 'Automatic deletion',
        noSharing: 'No data sharing'
      }
    },
    madeInFranceSection: {
      title: '🇫🇷 Made in France',
      subtitle: 'A 100% French solution for your file transfers',
      development: {
        title: 'French development',
        description: 'Designed and developed by French teams'
      },
      hosting: {
        title: 'French hosting',
        description: 'Data hosted on French territory'
      },
      support: {
        title: 'French support',
        description: 'French technical support team'
      }
    },
    footer: '© 2024 ProTransfert - French secure file transfer solution'
  },

  // Contact page
  contact: {
    title: 'Contact us',
    subtitle: 'Our French team is here to help you. Don\'t hesitate to contact us for any questions about ProTransfert.',
    form: {
      name: 'Full name *',
      namePlaceholder: 'Your full name',
      email: 'Email *',
      emailPlaceholder: 'your@email.com',
      company: 'Company',
      companyPlaceholder: 'Your company name',
      phone: 'Phone',
      phonePlaceholder: 'Your phone number',
      subject: 'Subject *',
      subjectPlaceholder: 'Subject of your request',
      message: 'Message *',
      messagePlaceholder: 'Describe your request in detail...',
      characters: 'characters',
      submit: 'Send message',
      sending: 'Sending...',
      success: 'Your request has been sent successfully. You will receive a confirmation email.',
      error: 'Connection error. Please try again.'
    },
    validation: {
      nameRequired: 'Name is required',
      nameMinLength: 'Name must contain at least 2 characters',
      emailRequired: 'Email is required',
      emailInvalid: 'Email is not valid',
      subjectRequired: 'Subject is required',
      subjectMinLength: 'Subject must contain at least 5 characters',
      messageRequired: 'Message is required',
      messageMinLength: 'Message must contain at least 10 characters',
      messageMaxLength: 'Message cannot exceed 1000 characters'
    },
    info: {
      email: {
        title: 'Email',
        value: 'contact@protransfert.com'
      },
      location: {
        title: 'Location',
        value: 'France'
      },
      response: {
        title: 'Response',
        value: 'Within 24-48h'
      }
    },
    rgpd: {
      title: 'Data protection',
      description: 'Your personal data is collected solely to process your contact request. It will not be shared with third parties and will be deleted after processing. In accordance with GDPR, you have the right to access, rectify and delete your data.'
    }
  },

  // Confirmation page
  confirm: {
    title: 'File sent successfully!',
    subtitle: 'Your file has been shared successfully.',
    downloadLink: 'Download link',
    copyLink: 'Copy link',
    linkCopied: 'Link copied!',
    shareViaEmail: 'Share via email',
    emailSent: 'Email sent!',
    expiration: 'This link will expire on',
    newUpload: 'Send another file'
  },

  // Download page
  download: {
    title: 'File download',
    downloadButton: 'Download file',
    downloading: 'Downloading...',
    fileNotFound: 'File not found',
    fileExpired: 'This file has expired',
    fileSize: 'File size',
    uploadedBy: 'Shared by',
    uploadedOn: 'Shared on',
    expiresOn: 'Expires on',
    message: 'Message',
    noMessage: 'No message'
  },

  // Admin
  admin: {
    dashboard: {
      title: 'Dashboard',
      connectedAs: 'Connected as',
      files: 'Files',
      companies: 'Companies',
      users: 'Users',
      stats: 'Statistics'
    }
  },

  // Authentication
  auth: {
    login: {
      title: 'Login',
      subtitle: 'Sign in to your ProTransfert account',
      email: 'Email',
      emailPlaceholder: 'your@email.com',
      password: 'Password',
      passwordPlaceholder: 'Your password',
      login: 'Sign in',
      loggingIn: 'Signing in...',
      or: 'or',
      googleSignIn: 'Sign in with Google',
      dontHaveAccount: 'Don\'t have an account?',
      signUp: 'Sign up',
      error: 'Login error',
      googleAuthFailed: 'Google authentication failed'
    },
    register: {
      title: 'Sign up',
      subtitle: 'Create your ProTransfert account',
      name: 'Full name',
      namePlaceholder: 'Your full name',
      email: 'Email',
      emailPlaceholder: 'your@email.com',
      password: 'Password',
      passwordPlaceholder: 'Your password',
      confirmPassword: 'Confirm password',
      confirmPasswordPlaceholder: 'Confirm your password',
      register: 'Sign up',
      registering: 'Signing up...',
      or: 'or',
      googleSignUp: 'Sign up with Google',
      alreadyHaveAccount: 'Already have an account?',
      signIn: 'Sign in',
      passwordMismatch: 'Passwords do not match',
      passwordTooShort: 'Password must be at least 6 characters',
      error: 'Registration error'
    },
    callback: {
      authenticating: 'Authenticating...',
      pleaseWait: 'Please wait',
      error: 'Authentication error',
      noToken: 'No authentication token received',
      verificationFailed: 'Token verification failed',
      backToLogin: 'Back to login'
    },
    welcome: 'Welcome',
    logout: 'Logout'
  },

  // Common messages
  common: {
    loading: 'Loading...',
    error: 'An error occurred',
    success: 'Operation successful',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    yes: 'Yes',
    no: 'No',
    required: 'Required',
    optional: 'Optional'
  }
} 